import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Sales from './containers/Sales';
import CashDesk from './containers/CashDesk';
import TicketSales from './containers/TicketSales';
import TicketGratis from './containers/TicketGratis';
import TicketDetail from './containers/TicketDetail';
import TicketCanceled from './containers/TicketCanceled';
import CashDeskList from './containers/CashDeskList';
import CashDeskListTicket from './components/CashDeskListTicket';
import TicketCashDeskDetail from './containers/TicketCashDeskDetail';
export default class Index extends Component {
    render() {
        return (React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/sales", component: Sales }),
            React.createElement(Route, { exact: true, path: "/cashdesk", component: CashDesk }),
            React.createElement(Route, { exact: true, path: "/tickets", component: TicketSales }),
            React.createElement(Route, { exact: true, path: "/ticketGratis", component: TicketGratis }),
            React.createElement(Route, { exact: true, path: "/ticketCanceled", component: TicketCanceled }),
            React.createElement(Route, { exact: true, path: "/tickets/:id", render: (props) => React.createElement(TicketDetail, Object.assign({}, props)) }),
            React.createElement(Route, { exact: true, path: "/ticketCashDesk", render: (props) => React.createElement(TicketCashDeskDetail, Object.assign({}, props)) }),
            React.createElement(Route, { exact: true, path: "/cashDeskList", component: CashDeskList }),
            React.createElement(Route, { exact: true, path: "/cashDeskList/:numero", component: CashDeskListTicket })));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/index.tsx
// module id = 230
// module chunks = 0